var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.show
    ? _c("SoliResponsiveDialog", {
        attrs: { title: "Rename Conversation", mobileScroll: false },
        on: {
          reset: function ($event) {
            return _vm.reset()
          },
        },
        scopedSlots: _vm._u(
          [
            {
              key: "body",
              fn: function () {
                return [
                  _c(
                    "v-container",
                    [
                      _c(
                        "v-form",
                        {
                          on: {
                            submit: function ($event) {
                              $event.preventDefault()
                              return _vm.submit.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.valid,
                            callback: function ($$v) {
                              _vm.valid = $$v
                            },
                            expression: "valid",
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "flex flex-col gap-6" },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  autofocus: "",
                                  placeholder: "Name",
                                  outlined: "",
                                  dense: "",
                                  "hide-details": "auto",
                                },
                                model: {
                                  value: _vm.form.name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "name", $$v)
                                  },
                                  expression: "form.name",
                                },
                              }),
                              _vm._v(" "),
                              _c("SoliBtn", {
                                attrs: {
                                  text: "Save",
                                  icon: "save",
                                  block: "",
                                  gradient: "gradient-orange",
                                  loading: _vm.form.processing,
                                  type: "submit",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          false,
          2482660363
        ),
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }